import { ExportType } from "../enums";

export const BalanceHistoryExportDropdownData = [
  {
    value: ExportType.Excel,
    label: "Excel",
  },
  {
    value: ExportType.Csv,
    label: "CSV",
  }
];